import dayjs, { type ManipulateType } from "dayjs";

type Period = {
	length: number;
	unit: ManipulateType;
};
export default function isDateAfterPeriod(
	date: Date,
	refDate?: Date,
	period: Period = { length: 1, unit: "year" },
) {
	const ago = dayjs(refDate).subtract(period.length, period.unit);
	return dayjs(date).isAfter(ago);
}
